import { render, staticRenderFns } from "./PageAttribute.vue?vue&type=template&id=1e4eb4a6&"
import script from "./PageAttribute.vue?vue&type=script&lang=js&"
export * from "./PageAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e4eb4a6')) {
      api.createRecord('1e4eb4a6', component.options)
    } else {
      api.reload('1e4eb4a6', component.options)
    }
    module.hot.accept("./PageAttribute.vue?vue&type=template&id=1e4eb4a6&", function () {
      api.rerender('1e4eb4a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/attribute/PageAttribute.vue"
export default component.exports